/* components/Catalog.svelte generated by Svelte v3.20.1 */
import {
	SvelteComponent,
	append,
	attr,
	check_outros,
	component_subscribe,
	create_component,
	destroy_component,
	destroy_each,
	detach,
	element,
	empty,
	group_outros,
	init,
	insert,
	listen,
	mount_component,
	noop,
	prevent_default,
	run_all,
	safe_not_equal,
	set_data,
	space,
	text,
	transition_in,
	transition_out
} from "svelte/internal";

import { Link } from "svelte-routing";
import { fetchUsers } from "../client.js";
import dataStore from "../stores/catalog.js";
import { writable, get } from "svelte/store";
import Preloader from "./Preloader.svelte";

function add_css() {
	var style = element("style");
	style.id = "svelte-uox16z-style";
	style.textContent = ".preloader.svelte-uox16z{text-align:center;height:250px}.pager.svelte-uox16z{display:flex;justify-content:space-around}";
	append(document.head, style);
}

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[8] = list[i];
	return child_ctx;
}

// (62:4) {:else}
function create_else_block(ctx) {
	let tr;
	let td;
	let current;
	const preloader = new Preloader({});

	return {
		c() {
			tr = element("tr");
			td = element("td");
			create_component(preloader.$$.fragment);
			attr(td, "colspan", "3");
			attr(td, "class", "preloader svelte-uox16z");
		},
		m(target, anchor) {
			insert(target, tr, anchor);
			append(tr, td);
			mount_component(preloader, td, null);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(preloader.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(preloader.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(tr);
			destroy_component(preloader);
		}
	};
}

// (49:4) {#if !$catalog.loading}
function create_if_block_2(ctx) {
	let each_1_anchor;
	let current;
	let each_value = /*$catalog*/ ctx[1].data;
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	const out = i => transition_out(each_blocks[i], 1, 1, () => {
		each_blocks[i] = null;
	});

	return {
		c() {
			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			each_1_anchor = empty();
		},
		m(target, anchor) {
			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(target, anchor);
			}

			insert(target, each_1_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			if (dirty & /*$catalog*/ 2) {
				each_value = /*$catalog*/ ctx[1].data;
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
						transition_in(each_blocks[i], 1);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						transition_in(each_blocks[i], 1);
						each_blocks[i].m(each_1_anchor.parentNode, each_1_anchor);
					}
				}

				group_outros();

				for (i = each_value.length; i < each_blocks.length; i += 1) {
					out(i);
				}

				check_outros();
			}
		},
		i(local) {
			if (current) return;

			for (let i = 0; i < each_value.length; i += 1) {
				transition_in(each_blocks[i]);
			}

			current = true;
		},
		o(local) {
			each_blocks = each_blocks.filter(Boolean);

			for (let i = 0; i < each_blocks.length; i += 1) {
				transition_out(each_blocks[i]);
			}

			current = false;
		},
		d(detaching) {
			destroy_each(each_blocks, detaching);
			if (detaching) detach(each_1_anchor);
		}
	};
}

// (53:8) <Link to={`/zf/user/${item.id}`}>
function create_default_slot(ctx) {
	let t_value = /*item*/ ctx[8].name + "";
	let t;

	return {
		c() {
			t = text(t_value);
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		p(ctx, dirty) {
			if (dirty & /*$catalog*/ 2 && t_value !== (t_value = /*item*/ ctx[8].name + "")) set_data(t, t_value);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (50:5) {#each $catalog.data as item}
function create_each_block(ctx) {
	let tr;
	let td0;
	let t0;
	let td1;
	let t1_value = /*item*/ ctx[8].email + "";
	let t1;
	let t2;
	let td2;
	let t3_value = /*item*/ ctx[8].phone + "";
	let t3;
	let t4;
	let current;

	const link = new Link({
			props: {
				to: `/zf/user/${/*item*/ ctx[8].id}`,
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			tr = element("tr");
			td0 = element("td");
			create_component(link.$$.fragment);
			t0 = space();
			td1 = element("td");
			t1 = text(t1_value);
			t2 = space();
			td2 = element("td");
			t3 = text(t3_value);
			t4 = space();
		},
		m(target, anchor) {
			insert(target, tr, anchor);
			append(tr, td0);
			mount_component(link, td0, null);
			append(tr, t0);
			append(tr, td1);
			append(td1, t1);
			append(tr, t2);
			append(tr, td2);
			append(td2, t3);
			append(tr, t4);
			current = true;
		},
		p(ctx, dirty) {
			const link_changes = {};
			if (dirty & /*$catalog*/ 2) link_changes.to = `/zf/user/${/*item*/ ctx[8].id}`;

			if (dirty & /*$$scope, $catalog*/ 2050) {
				link_changes.$$scope = { dirty, ctx };
			}

			link.$set(link_changes);
			if ((!current || dirty & /*$catalog*/ 2) && t1_value !== (t1_value = /*item*/ ctx[8].email + "")) set_data(t1, t1_value);
			if ((!current || dirty & /*$catalog*/ 2) && t3_value !== (t3_value = /*item*/ ctx[8].phone + "")) set_data(t3, t3_value);
		},
		i(local) {
			if (current) return;
			transition_in(link.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(link.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(tr);
			destroy_component(link);
		}
	};
}

// (81:1) {#if page > 1}
function create_if_block_1(ctx) {
	let a;
	let t0_value = /*page*/ ctx[0] - 1 + "";
	let t0;
	let t1;
	let dispose;

	return {
		c() {
			a = element("a");
			t0 = text(t0_value);
			t1 = text("\n\t\t ");
			attr(a, "class", "button");
			attr(a, "href", "#");
		},
		m(target, anchor, remount) {
			insert(target, a, anchor);
			append(a, t0);
			insert(target, t1, anchor);
			if (remount) dispose();
			dispose = listen(a, "click", prevent_default(/*click_handler_1*/ ctx[5]));
		},
		p(ctx, dirty) {
			if (dirty & /*page*/ 1 && t0_value !== (t0_value = /*page*/ ctx[0] - 1 + "")) set_data(t0, t0_value);
		},
		d(detaching) {
			if (detaching) detach(a);
			if (detaching) detach(t1);
			dispose();
		}
	};
}

// (93:1) {#if page + 1 <= $catalog.totalPages}
function create_if_block(ctx) {
	let a;
	let t0_value = /*page*/ ctx[0] + 1 + "";
	let t0;
	let t1;
	let dispose;

	return {
		c() {
			a = element("a");
			t0 = text(t0_value);
			t1 = text("\n\t\t ");
			attr(a, "class", "button");
			attr(a, "href", "#");
		},
		m(target, anchor, remount) {
			insert(target, a, anchor);
			append(a, t0);
			insert(target, t1, anchor);
			if (remount) dispose();
			dispose = listen(a, "click", prevent_default(/*click_handler_2*/ ctx[6]));
		},
		p(ctx, dirty) {
			if (dirty & /*page*/ 1 && t0_value !== (t0_value = /*page*/ ctx[0] + 1 + "")) set_data(t0, t0_value);
		},
		d(detaching) {
			if (detaching) detach(a);
			if (detaching) detach(t1);
			dispose();
		}
	};
}

function create_fragment(ctx) {
	let div1;
	let div0;
	let table;
	let thead;
	let t5;
	let tbody;
	let current_block_type_index;
	let if_block0;
	let t6;
	let div2;
	let a0;
	let t8;
	let t9;
	let a1;
	let t10;
	let t11;
	let t12;
	let a2;
	let current;
	let dispose;
	const if_block_creators = [create_if_block_2, create_else_block];
	const if_blocks = [];

	function select_block_type(ctx, dirty) {
		if (!/*$catalog*/ ctx[1].loading) return 0;
		return 1;
	}

	current_block_type_index = select_block_type(ctx, -1);
	if_block0 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
	let if_block1 = /*page*/ ctx[0] > 1 && create_if_block_1(ctx);
	let if_block2 = /*page*/ ctx[0] + 1 <= /*$catalog*/ ctx[1].totalPages && create_if_block(ctx);

	return {
		c() {
			div1 = element("div");
			div0 = element("div");
			table = element("table");
			thead = element("thead");

			thead.innerHTML = `<tr><th>Name</th> 
					<th>E-Mail</th> 
					<th>Phone</th></tr>`;

			t5 = space();
			tbody = element("tbody");
			if_block0.c();
			t6 = space();
			div2 = element("div");
			a0 = element("a");
			a0.textContent = "««";
			t8 = text("\n\t \n\t");
			if (if_block1) if_block1.c();
			t9 = space();
			a1 = element("a");
			t10 = text(/*page*/ ctx[0]);
			t11 = text("\n\t \n\t");
			if (if_block2) if_block2.c();
			t12 = space();
			a2 = element("a");
			a2.textContent = "»»";
			attr(div0, "class", "column");
			attr(div1, "class", "row");
			attr(a0, "class", "button");
			attr(a0, "href", "#");
			attr(a1, "class", "button button-outline");
			attr(a1, "href", "#");
			attr(a2, "class", "button");
			attr(a2, "href", "#");
			attr(div2, "class", "row pager svelte-uox16z");
		},
		m(target, anchor, remount) {
			insert(target, div1, anchor);
			append(div1, div0);
			append(div0, table);
			append(table, thead);
			append(table, t5);
			append(table, tbody);
			if_blocks[current_block_type_index].m(tbody, null);
			insert(target, t6, anchor);
			insert(target, div2, anchor);
			append(div2, a0);
			append(div2, t8);
			if (if_block1) if_block1.m(div2, null);
			append(div2, t9);
			append(div2, a1);
			append(a1, t10);
			append(div2, t11);
			if (if_block2) if_block2.m(div2, null);
			append(div2, t12);
			append(div2, a2);
			current = true;
			if (remount) run_all(dispose);

			dispose = [
				listen(a0, "click", prevent_default(/*click_handler*/ ctx[4])),
				listen(a2, "click", prevent_default(/*click_handler_3*/ ctx[7]))
			];
		},
		p(ctx, [dirty]) {
			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type(ctx, dirty);

			if (current_block_type_index === previous_block_index) {
				if_blocks[current_block_type_index].p(ctx, dirty);
			} else {
				group_outros();

				transition_out(if_blocks[previous_block_index], 1, 1, () => {
					if_blocks[previous_block_index] = null;
				});

				check_outros();
				if_block0 = if_blocks[current_block_type_index];

				if (!if_block0) {
					if_block0 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
					if_block0.c();
				}

				transition_in(if_block0, 1);
				if_block0.m(tbody, null);
			}

			if (/*page*/ ctx[0] > 1) {
				if (if_block1) {
					if_block1.p(ctx, dirty);
				} else {
					if_block1 = create_if_block_1(ctx);
					if_block1.c();
					if_block1.m(div2, t9);
				}
			} else if (if_block1) {
				if_block1.d(1);
				if_block1 = null;
			}

			if (!current || dirty & /*page*/ 1) set_data(t10, /*page*/ ctx[0]);

			if (/*page*/ ctx[0] + 1 <= /*$catalog*/ ctx[1].totalPages) {
				if (if_block2) {
					if_block2.p(ctx, dirty);
				} else {
					if_block2 = create_if_block(ctx);
					if_block2.c();
					if_block2.m(div2, t12);
				}
			} else if (if_block2) {
				if_block2.d(1);
				if_block2 = null;
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block0);
			current = true;
		},
		o(local) {
			transition_out(if_block0);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div1);
			if_blocks[current_block_type_index].d();
			if (detaching) detach(t6);
			if (detaching) detach(div2);
			if (if_block1) if_block1.d();
			if (if_block2) if_block2.d();
			run_all(dispose);
		}
	};
}

let limit = 5;

function instance($$self, $$props, $$invalidate) {
	let $catalog;
	const catalog = dataStore(fetchUsers);
	component_subscribe($$self, catalog, value => $$invalidate(1, $catalog = value));
	let { page = parseInt(new URLSearchParams(location.search).get("page")) || 1 } = $$props;

	function showPage(currentPage = 1) {
		$$invalidate(0, page = currentPage);
		catalog.fetchQuery({ page, limit });
		localStorage.setItem("lp", page);
	}

	showPage(page);
	const click_handler = () => showPage(1);
	const click_handler_1 = () => showPage(page - 1);
	const click_handler_2 = () => showPage(page + 1);
	const click_handler_3 = () => showPage($catalog.totalPages);

	$$self.$set = $$props => {
		if ("page" in $$props) $$invalidate(0, page = $$props.page);
	};

	return [
		page,
		$catalog,
		catalog,
		showPage,
		click_handler,
		click_handler_1,
		click_handler_2,
		click_handler_3
	];
}

class Catalog extends SvelteComponent {
	constructor(options) {
		super();
		if (!document.getElementById("svelte-uox16z-style")) add_css();
		init(this, options, instance, create_fragment, safe_not_equal, { page: 0 });
	}
}

export default Catalog;